<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<h2 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Questionari {{type.toUpperCase()}}</h2>

<div class="container">
  <mat-card class="mat-elevation-z5">
    <ng-container *ngIf="toShow !== null && toShow.length > 0; else notFound">
      <mat-list>
        <ng-container *ngIf="toShow">
          <mat-list-item *ngFor="let r of toShow">
            <mat-icon mat-list-icon>folder</mat-icon>
            <div mat-line style="cursor: pointer" (click)="goTo(r)">{{r.id.split('-')[0]}}
              <ng-container *ngIf="type.localeCompare('hbi') === 0">
                <ng-container *ngIf="r.finalScore < 5">
                  <span class="material-icons icon" style="color: mediumseagreen">thumb_up</span>
                </ng-container>
                <ng-container *ngIf="r.finalScore >= 5 && r.finalScore <= 7">
                  <span class="material-icons icon" style="color: #fff73b">error</span>
                </ng-container>
                <ng-container *ngIf="r.finalScore > 7">
                  <span class="material-icons icon" style="color: red">error</span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="type.localeCompare('patient-sccai') === 0">
                <ng-container *ngIf="r.finalScore < 5">
                  <span class="material-icons icon" style="color: mediumseagreen">thumb_up</span>
                </ng-container>
                <ng-container *ngIf="r.finalScore >= 5">
                  <span class="material-icons icon" style="color: red">error</span>
                </ng-container>
              </ng-container>
            </div>
          </mat-list-item>
        </ng-container>
      </mat-list>
    </ng-container>
  </mat-card>
</div>

<ng-template #notFound>
  <h3 style="text-align: center;">Nessun questionario trovato. Torna indietro.</h3>
</ng-template>
